// services/api/boq/moduleService.js
import api from "../../../utils/api";

// Fetch all modules
export const fetchModulesApi = async () => {
  const res = await api.get("/admin/modules");
  return res.data;
};

// Create a new module
export const createModuleApi = async (payload) => {
  const res = await api.post("/admin/modules", payload);
  return res.data;
};

// Update module (e.g., change name)
export const updateModuleApi = async (id, payload) => {
  const res = await api.put(`/admin/modules/${id}`, payload);
  return res.data;
};

// Toggle module status (enable/disable)
export const toggleModuleStatusApi = async (id, payload) => {
  const res = await api.patch(`/admin/modules/${id}/status`, payload);
  return res.data;
};

// Delete a module
export const deleteModuleApi = async (id) => {
  const res = await api.delete(`/admin/modules/${id}`);
  return res.data;
};